// The AI ledger's feature slugs (worker lib/aiCalls.ts featureForKind) in words
// for the « Coûts IA » page (owner, 2026-10-22). Admin screen: « IA » is the
// owner's own word here. An unknown slug shows as itself.
const LABEL: Record<string, string> = {
  agent_reply: 'Réponses WhatsApp',
  edit_classify: 'Lecture des demandes',
  memory_extract: 'Mémoire client',
  intake_extract: 'Infos de commande',
  open_loops: 'Promesses à tenir',
  photo_vision: 'Analyse des photos',
  face_finder: 'Recherche de visages',
  page_check: 'Contrôle des pages',
  captions: 'Légendes',
  receipt_ocr: 'Lecture des reçus',
  satisfaction_read: 'Satisfaction',
  cancel_read: 'Annulations',
  orientation: 'Photos de travers',
  album_edit: 'Retouches d’album',
  admin_tools: 'Outils admin',
  image_kind: 'Type d’image reçue',
  voice_transcribe: 'Messages vocaux',
  template_classify: 'Modèles de pages',
  cover_tags: 'Mots-clés couvertures',
  cover_suggest: 'Suggestion de couverture',
  layout: 'Mise en page',
  preview_screenshot: 'Captures de l’aperçu',
  manager_ask: 'Questions au manager',
  manager_intro: 'Réponses enregistrées',
  manager_refine: 'Brain : affiner',
  manager_brain: 'Brain : généraliser',
  manager_operator: 'Opérateur (patron)',
  manager_relay: 'Relais manager',
  note_interpret: 'Notes d’aperçu',
  note_interpret_strong: 'Notes d’aperçu (modèle fort)',
  note_vision: 'Notes d’aperçu (image)',
  note_clarify: 'Notes à clarifier',
  note_orientation: 'Notes : rotation',
  note_orientation_after: 'Notes : rotation (contrôle)',
  cover_photo_title: 'Titre sur la couverture',
  // Agent v2 Phase D — the weekly learning run (worker lib/caseLibrary.ts, lib/playbooks.ts).
  agent_case_summary: 'Apprentissage : cas',
  agent_playbook_propose: 'Apprentissage : playbooks',
};

/** Every feature with a label, for the « Appels IA » filter (alphabetical by label). */
export const AI_FEATURES: Array<{ slug: string; label: string }> = Object.entries(LABEL)
  .map(([slug, label]) => ({ slug, label }))
  .sort((a, b) => a.label.localeCompare(b.label, 'fr'));

export function aiFeatureLabel(slug: string): string {
  return LABEL[slug] ?? slug;
}
